export default class ReportParameter {
  parameterId: string;
  parameterName: string;
  parameterField: string;
  lookupTableName: string;
  lookupField: string;
  dataType: string;
  sortOrderNumber: number;
  required: boolean;
  uiLineBreak: boolean;
  dateLockToFirstOfMonth = false;
  dateLockToLastOfMonth = false;
  dateMustBeGreaterThanParameterField: string;
  dateMustBeLessThanParameterField: string;
  dateAllowFutureDates = true;
  dateAllowPastDates = true;

  constructor(reportParameter?) {
    if (reportParameter) {
      this.parameterId = reportParameter.parameterId;
      this.parameterName = reportParameter.parameterName;
      this.parameterField = reportParameter.parameterField;
      this.lookupTableName = reportParameter.lookupTableName || null;
      this.lookupField = reportParameter.lookupField;
      this.dataType = reportParameter.dataType;
      this.sortOrderNumber = reportParameter.sortOrderNumber;
      this.required = reportParameter.required;
      this.uiLineBreak = reportParameter.uiLineBreak;
      this.dateLockToFirstOfMonth = reportParameter.dateLockToFirstOfMonth;
      this.dateLockToLastOfMonth = reportParameter.dateLockToLastOfMonth;
      this.dateMustBeGreaterThanParameterField = reportParameter.dateMustBeGreaterThanParameterField;
      this.dateMustBeLessThanParameterField = reportParameter.dateMustBeLessThanParameterField;
      this.dateAllowFutureDates = reportParameter.dateAllowFutureDates;
      this.dateAllowPastDates = reportParameter.dateAllowPastDates;
    }
  }
}
